import { Influencer } from "types/influencer"
import { SocialPost } from "../collaborations"

export interface CampaignPostsState {
    posts: {
        applied_filter_id: string | null,
        loading: boolean,
        error: string | null,
        filters: CampaignPostsFilters,
        items: Record<string, { // campaignId
            total: number,
            filtered_lists: Record<string, //FilterId
                {
                    items: CampaignPost[],
                    last_fetched_at: number,
                    error: string | null,
                    loading: boolean,
                    count: number,
                    has_more: boolean,
                    page: number,
                    filters: CampaignPostsFilters,
                    expired: boolean
                }>
        }>
    }
}

export interface CampaignPostsFilters {
    page: number,
    [key: string]: any
}

export interface CampaignPost {
    social_post: SocialPost,
    influencer?: Influencer
}


export enum SortOptions {
    POSTED_DATE = 'timestamp_tz',
    LIKE_COUNT = 'like_count',
    VIEWS_COUNT = 'views_count',
    ENGAGEMENT_SCORE = 'engagement_score',
    // AVERAGE_VIEWS = 'average_views',
}

export const SortOptionLabel = {
    [SortOptions.POSTED_DATE]: 'Posted Date',
    [SortOptions.LIKE_COUNT]: 'Like Count',
    [SortOptions.VIEWS_COUNT]: 'Views Count',
    [SortOptions.ENGAGEMENT_SCORE]: 'Engagement Score',
}


export enum PostTypeOptions {
    ALL = 'all',
    FEED = 'FEED',
    REELS = 'REELS',
    STORIES = 'STORY'
}

export const PostTypeOptionLabel = {
    [PostTypeOptions.ALL]: 'All',
    [PostTypeOptions.FEED]: 'Feed',
    [PostTypeOptions.REELS]: 'Reels',
    [PostTypeOptions.STORIES]: 'Stories',
}


export const defaultCampaignPostsFilters = {
    page: 1,
    sort: SortOptions.POSTED_DATE,
}


